const benefitData = [
    {
        id: 1,
        title: 'free shipping',
        description: 'Free shipping on orders over $35',
        icon: '#icon-shipping'
    },
    {
        id: 2,
        title: 'fast service',
        description: 'From order to shipping, everything is fast',
        icon: '#icon-rocket'
    },
    {
        id: 3,
        title: 'preorder gifts',
        description: 'Exclusive preorder gifts plus JYPE preorder benefits',
        icon: '#icon-gift'
    },
    {
        id: 4,
        title: 'instock on release',
        description: 'Newly released products available on launch',
        icon: '#icon-calendar'
    }
];

export default benefitData;